/** A static SEO fallback is not the same tree that React renders. */
export function shouldHydrateRoot(root: HTMLElement): boolean {
  return (
    root.hasChildNodes() && !root.querySelector('[data-prehydration-chrome]')
  );
}
